import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { COLUMNAS_EXPORT, FRANJAS_HORARIAS, DIES_SEMANA, isRealDate, normalizeDate } from "@/data/terrassa";

const today = () => new Date().toISOString().slice(0, 10);

const formatVal = (c, key) => {
  // La columna "Afiliado" tiene 3 estados (Sí / No / Baja) según fecha_baja
  if (key === "es_afiliado") {
    if (isRealDate(c.fecha_baja_afiliado)) return "Baja";
    return c.es_afiliado ? "Sí" : "No";
  }
  if (key === "es_apoderado") {
    if (isRealDate(c.fecha_baja_apoderado)) return "Baja";
    return c.es_apoderado ? "Sí" : "No";
  }
  if (key === "anios_apoderado") {
    return Array.isArray(c.anios_apoderado) ? c.anios_apoderado.join(", ") : "";
  }
  if (key === "consells_sectorials") {
    return Array.isArray(c.consells_sectorials) ? c.consells_sectorials.join(", ") : "";
  }
  if (key === "consells_districte") {
    return Array.isArray(c.consells_districte) ? c.consells_districte.join(", ") : "";
  }
  if (key === "tema") {
    return Array.isArray(c.tema) ? c.tema.join(", ") : (c.tema || "");
  }
  if (key === "voluntari_hoja_alta") {
    if (!c.es_voluntario) return "";
    return c.voluntario_file ? "Sí" : "No";
  }
  if (key === "voluntari_disponibilitat") {
    const slots = Array.isArray(c.voluntari_disponibilitat) ? c.voluntari_disponibilitat : [];
    if (!slots.length) return "";
    const parts = FRANJAS_HORARIAS
      .map((f) => {
        const dies = DIES_SEMANA
          .filter((d) => slots.includes(`${f.key}_${d.key}`))
          .map((d) => d.label);
        return dies.length ? `${f.label}: ${dies.join(", ")}` : null;
      })
      .filter(Boolean);
    return parts.join(" | ");
  }
  if (key === "voluntari_actes") {
    return Array.isArray(c.voluntari_actes) ? c.voluntari_actes.join(", ") : "";
  }
  if (key === "voluntari_horari_observacions" || key === "voluntari_equip") {
    return c[key] || "";
  }
  if (key === "fecha_baja_apoderado" || key === "fecha_baja_afiliado" || key === "fecha_alta_afiliado") {
    return normalizeDate(c[key]);
  }
  const v = c[key];
  if (typeof v === "boolean") return v ? "Sí" : "No";
  return v ?? "";
};

export function exportToExcel(contactos, selectedKeys) {
  const cols = COLUMNAS_EXPORT.filter((c) => selectedKeys.includes(c.key));
  const headers = cols.map((c) => c.label);
  const rows = contactos.map((c) => cols.map((col) => formatVal(c, col.key)));
  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
  // Auto column widths
  ws["!cols"] = cols.map((c, i) => {
    const maxLen = Math.max(
      c.label.length,
      ...rows.map((r) => String(r[i] ?? "").length)
    );
    return { wch: Math.min(maxLen + 2, 40) };
  });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Contactos");
  XLSX.writeFile(wb, `contactos_${today()}.xlsx`);
}

export function exportToPDF(contactos, selectedKeys) {
  const cols = COLUMNAS_EXPORT.filter((c) => selectedKeys.includes(c.key));
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });

  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("Base de datos de contactos", 40, 36);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.setTextColor(100);
  doc.text(
    `Generado: ${new Date().toLocaleString("es-ES")} · Registros: ${contactos.length}`,
    40,
    52
  );

  autoTable(doc, {
    startY: 70,
    head: [cols.map((c) => c.label)],
    body: contactos.map((c) => cols.map((col) => formatVal(c, col.key))),
    styles: { fontSize: 8, cellPadding: 4, overflow: "linebreak" },
    headStyles: { fillColor: [15, 23, 42], textColor: 255, fontStyle: "bold" },
    alternateRowStyles: { fillColor: [248, 250, 252] },
    margin: { left: 40, right: 40 },
  });

  doc.save(`contactos_${today()}.pdf`);
}
